import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React, { useState, useEffect } from "react";
import { PieChart, Pie, Cell, ResponsiveContainer, Sector } from "recharts";
import Skeleton from "react-loading-skeleton";
import * as d3 from "d3";
import { numeral, setLocale } from "../../../";
var COLORS = ["#33ff99", "#00cdd6", "#0093ff", "#0400b5"];
var RADIAN = Math.PI / 180; // const CustomTooltip = ({ active, payload, translation }) => {
// 	if (active) {
// 		return (
// 			<div className="custom-tooltip">
// 				<Typography variant="h5">{`${translation[payload[0].name]}: ${numeral(payload[0].value).format(
// 					'0,0[.]00 $'
// 				)}`}</Typography>
// 				<Typography variant="body2">{`${payload[0].payload.value.count}`}</Typography>
// 			</div>
// 		);
// 	}
// 	return null;
// };

var CustomPieChart = function CustomPieChart(_ref) {
  var data = _ref.data,
      groupedBy = _ref.groupedBy,
      acc = _ref.acc,
      translation = _ref.translation,
      locale = _ref.locale,
      props = _objectWithoutProperties(_ref, ["data", "groupedBy", "acc", "translation", "locale"]);

  // console.log('data en piechart molecule', data);
  // console.log('data en piechart molecule', groupedBy);
  // console.log('translation en piechart molecule', translation);
  var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      pieData = _useState2[0],
      setPieData = _useState2[1];

  var _useState3 = useState(0),
      _useState4 = _slicedToArray(_useState3, 2),
      activeIndex = _useState4[0],
      setActiveIndex = _useState4[1];

  useEffect(function () {
    setPieData(d3.nest().key(function (d) {
      // d[groupedBy])
      var splitted = groupedBy.split(".");
      return splitted.length === 1 ? d[splitted[0]] : d[splitted[0]][splitted[1]];
    }).rollup(function (v) {
      return {
        count: v.length,
        total: +d3.sum(v, function (d) {
          var splitted = acc.split(".");
          return splitted.length === 1 ? d[splitted[0]] : d[splitted[0]][splitted[1]];
        }).toFixed(0) // avg: d3.mean(v, (d) => d[acc]).toFixed(0)

      };
    }).entries(data));
  }, [data, groupedBy]);
  useEffect(function () {
    setLocale(locale);
  }, [locale]);

  var renderActiveShape = function renderActiveShape(props) {
    // console.log("renderActiveShape props", props);
    var cx = props.cx,
        cy = props.cy,
        midAngle = props.midAngle,
        innerRadius = props.innerRadius,
        outerRadius = props.outerRadius,
        startAngle = props.startAngle,
        endAngle = props.endAngle,
        fill = props.fill,
        payload = props.payload,
        percent = props.percent,
        value = props.value;
    var sin = Math.sin(-RADIAN * midAngle);
    var cos = Math.cos(-RADIAN * midAngle);
    var sx = cx + (outerRadius + 10) * cos;
    var sy = cy + (outerRadius + 10) * sin;
    var mx = cx + (outerRadius + 30) * cos;
    var my = cy + (outerRadius + 30) * sin;
    var ex = mx + (cos >= 0 ? 1 : -1) * 22;
    var ey = my;
    var textAnchor = cos >= 0 ? "start" : "end"; // console.log('payload', payload)

    return /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
      x: cx,
      y: 100,
      dy: 0,
      textAnchor: "middle",
      fill: fill,
      "font-family": "Montserrat"
    }, /*#__PURE__*/React.createElement("tspan", {
      x: cx,
      dy: "1.2em",
      "font-weight": "bold",
      fill: "#fff"
    }, " ", translation ? translation[payload.key] : "key sin traducir"), /*#__PURE__*/React.createElement("tspan", {
      x: cx,
      dy: "1.2em"
    }, " ", "".concat(numeral(value).format("0,0[.]00 $"))), /*#__PURE__*/React.createElement("tspan", {
      x: cx,
      dy: "1.2em"
    }, " ", "".concat((percent * 100).toFixed(2), "%"))), /*#__PURE__*/React.createElement(Sector, {
      cx: cx,
      cy: cy,
      innerRadius: innerRadius,
      outerRadius: outerRadius,
      startAngle: startAngle,
      endAngle: endAngle,
      fill: fill
    }), /*#__PURE__*/React.createElement(Sector, {
      cx: cx,
      cy: cy,
      startAngle: startAngle,
      endAngle: endAngle,
      innerRadius: outerRadius + 6,
      outerRadius: outerRadius + 10,
      fill: fill
    }));
  };

  var onPieEnter = function onPieEnter(data, index) {
    setActiveIndex(index);
  };

  if (pieData.length) {
    // console.log('piechart props', props);
    return /*#__PURE__*/React.createElement(ResponsiveContainer, {
      height: props.height + 50
    }, /*#__PURE__*/React.createElement(PieChart, {
      height: props.height,
      width: props.width,
      stroke: "none"
    }, /*#__PURE__*/React.createElement(Pie, {
      data: pieData,
      activeShape: renderActiveShape,
      activeIndex: activeIndex,
      cy: props.height / 2,
      cx: props.width / 2,
      innerRadius: 80,
      outerRadius: 100,
      dataKey: "value.total",
      nameKey: "key",
      onMouseEnter: onPieEnter // label={renderCustomizedLabel}

    }, pieData.map(function (entry, index) {
      return /*#__PURE__*/React.createElement(Cell, {
        stroke: "none",
        key: "cell-".concat(entry.key),
        fill: COLORS[index % COLORS.length]
      });
    }))));
  } else return /*#__PURE__*/React.createElement(Skeleton, {
    height: 300,
    duration: 1
  });
};

export { CustomPieChart };